
class ShippingCountdown {
  /**
    * @param {HTMLElement} labelEl     The <span> where "Ships today…" is displayed
    * @param {HTMLElement} messageEl   The <p> containing the countdown <span>
    * @param {number}      hours       Countdown hours (default is 12)
    */
  constructor(labelEl, messageEl, hours = 12) {
    this.labelEl = labelEl;
    this.messageEl = messageEl;
    this.timerSpan = messageEl.querySelector('span');
    this.hours = hours;
    this.dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    });
    this.intervalId = null;
    this.init();
  }

  init() {
    if (!this.labelEl || !this.messageEl || !this.timerSpan) {
      console.warn('ShippingCountdown: Required elements not found');
      return;
    }
    this.setShipLabel('today');
    this.endTime = Date.now() + this.hours * 3600 * 1000;
    this.startTimer();
  }

  setShipLabel(day) {
    const text =
      day === 'today'
        ? `Ships today, ${this.dateFormatter.format(new Date())}`
        : 'Ships tomorrow';
    this.labelEl.textContent = text;
  }

  formatDuration(ms) {
    const totalSec = Math.floor(ms / 1000);
    const hrs = Math.floor(totalSec / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;
    return `${hrs}hr ${mins}mins ${secs}sec`;
  }

  update() {
    const now = Date.now();
    const delta = this.endTime - now;
    if (delta <= 0) {
      clearInterval(this.intervalId);
      this.messageEl.style.display = 'none';
      this.setShipLabel('tomorrow');
      return;
    }
    this.timerSpan.textContent = this.formatDuration(delta);
  }

  startTimer() {
    this.update();
    this.intervalId = setInterval(() => this.update(), 1000);
  }

  destroy() {
    clearInterval(this.intervalId);
  }
}

const SELECTORS = {
  shippingLabel: '.advertorial-improvements-product-card__shipping',
  shippingMessage: '.advertorial-improvements-product-card__shipping-message',
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll(SELECTORS.shippingLabel)
    .forEach(labelEl => {
      const messageEl = labelEl.parentElement.querySelector(
        SELECTORS.shippingMessage
      );
      if (messageEl) new ShippingCountdown(labelEl, messageEl, 12);
    });
});
